import {
  customStorageUtil,
  brazeLogCustomEvent,
  brazeRegisterUser,
  brazeLogChangeUser,
  brazeSetCustomUserAttribute,
  setAppLanguageAndCountry,
  setBrazeInitialized
} from '@mafc/common'
import Braze from 'utils/braze'
import MD5 from 'crypto-js/md5'
import Base64 from 'crypto-js/enc-base64'

const initializeBraze = (
  appboy: any,
  store: any,
  appConfig: any,
  parsed: any
) => {
  if (appboy) {
    const userId =
      appConfig &&
      appConfig?.userCredentials &&
      appConfig?.userCredentials?.userId
    const { initStorageManager } = customStorageUtil
    const storage = initStorageManager(() => localStorage)

    Braze.initializeBraze(appboy).then(({ appboy: initilizedAppBoy }) => {
      store.current.dispatch(setBrazeInitialized(true))
      ;(window as any).appboy = initilizedAppBoy

      if (typeof parsed === 'object' && parsed?.length) {
        parsed.map((i: any) => {
          brazeLogCustomEvent('add_to_cart', i)
        })
        if (parsed.length >= 1)
          brazeSetCustomUserAttribute({
            cart_count: parsed.length >= 1
          })

        storage.setItem('initBrazeAnonymousUserWithData', 'true')
      }
      if (!userId) {
        setAppLanguageAndCountry(appConfig, appboy)
      }

      const userRegistered = storage.getItem('userRegistered')
      const userLoggedIn = storage.getItem('userLoggedIn')

      if (userId && (userLoggedIn || userRegistered)) {
        const hash = MD5(userId?.toLowerCase())
        const hashedUserId = Base64.stringify(hash)

        brazeLogChangeUser(hashedUserId)
        if (userRegistered) {
          const { brazeData } = store.current.getState().appConfig

          if (brazeData?.birthday) {
            const bday = new Date(brazeData.birthday)

            brazeData.bdayDate = bday.getDate()
            brazeData.bdayMonth = bday.getMonth() + 1
            brazeData.bdayYear = bday.getFullYear()
          }
          brazeData && brazeRegisterUser(brazeData)
        }
        storage.removeItem('initBrazeAnonymousUserWithData')
      }
    })
  } else {
    console.error('Braze appboy library is not loaded!!')
  }
}

export default initializeBraze
